<template>
  <div class="pa-4">
    <v-card-title class="section-title pa-2">
      {{ value.title }}
    </v-card-title>
    <v-card-subtitle class="ma-0 pa-2">
      {{ value.description }}
    </v-card-subtitle>

    <v-row v-for="(item, index) in value" :key="index" class="mt-5">
      <p class="mr-5">{{ item.name }}</p>
      <v-col v-for="({product}, i) in item.items" :key="i" cols="12">
        <card-maker :color="value" :data="product"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CardMaker from "@/view/components/Product/cardMakr";

export default {
  name: "productsList",

  components: {CardMaker},

  props: {
    value: Object,
  }
}
</script>

<style scoped>
.section-title {
  position: relative;
}

.section-title:before {
  content: '';
  width: 150px;
  height: 1px;
  background: var(--v-primary-base);
  position: absolute;;
  bottom: 0;
  right: 0;
}
</style>